import axios from "axios";
import { API_BASE_URL } from "./common";
const OFFSITE_GET_DATA = `${API_BASE_URL}/offsite/get-offsite-vehicles`;
const CHANGE_OFFSITE_STATUS = `${API_BASE_URL}/offsite/change-status`;

export const offsiteGetData = async ({
  authToken,
  location_id,
  page = 1,
  limit = 20,
  vehicleNumber,
  ...payload
}) => {
  const response = await axios({
    method: "POST",
    data: {
      auth: authToken,
      location_id: location_id,
      is_archived: "0",
      // processing_status: "all",
      page,
      limit,
      ...payload,
      // make: "FORD",
    },
    url: OFFSITE_GET_DATA,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const changeOffsiteStatus = async (props) => {
  const response = await axios({
    method: "POST",
    data: { ...props },
    url: CHANGE_OFFSITE_STATUS,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};
